var _ = require('lodash')
var deepFilterInjectLodash = require('./deep-filter-factory')

module.exports = deepFilterInjectLodash(_)
